var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00634766H513V341.997H0V-0.00634766Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.132 148.694L429.526 159.143H440.511L431.623 165.599L435.018 176.047L426.132 169.59L417.243 176.047L420.638 165.599L411.751 159.143H422.735L426.132 148.694ZM386.861 223.913L391.954 239.586H408.431L395.1 249.272L400.192 264.942L386.861 255.256L373.53 264.942L378.623 249.272L365.292 239.586H381.769L386.861 223.913ZM388.345 100.827L392.589 113.889H406.32L395.21 121.958L399.454 135.018L388.345 126.946L377.235 135.018L381.479 121.958L370.37 113.889H384.101L388.345 100.827ZM350.559 148.24L355.651 163.911H372.129L358.797 173.596L363.891 189.268L350.559 179.583L337.228 189.268L342.32 173.596L328.989 163.911H345.466L350.559 148.24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.503 -0.0112305V30.6125L211.237 55.7495H256.503V115.224H197.274L256.503 148.135V170.985H229.761L156.133 130.079V170.985H100.373V122.317L12.7728 170.985H0.00292969V140.372L45.2592 115.224H0.00292969V55.7495H59.2214L0.00292969 22.8513V-0.0112305H26.735L100.373 40.9065V-0.0112305H156.133V48.6566L243.734 -0.0112305H256.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.0102539H112.219V69.4592H0V101.522H112.219V170.991H144.281V101.522H256.5V69.4592H144.281V-0.0102539Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 115.229L256.5 170.991V155.221L184.513 115.229H156.13Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 115.229L256.5 170.991V155.221L184.513 115.229H156.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 115.229L256.5 170.991V155.221L184.513 115.229H156.13ZM71.9863 115.229L0 155.221V170.991L100.37 115.229H71.9863Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 55.7514L0 -0.0102539V15.7585L71.9873 55.7514H100.37Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 55.7514L0 -0.0102539V15.7585L71.9873 55.7514H100.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 55.7514L0 -0.0102539V15.7585L71.9873 55.7514H100.37ZM184.514 55.7514L256.5 15.7585V-0.0102539L156.13 55.7514H184.514Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/NZ.196b30c635c6cfc60c9cb74d0bd8405a.svg";
export { ForwardRef as ReactComponent };